import { useContext } from 'react';

import { SelectedPolygonContext } from '../contexts/selected-polygon.context';

export const useSelectedPolygon = () => {
	return useContext(SelectedPolygonContext);
};
